export const ApplicationTypes = {
    PAYMENTS: 'PAYMENTS',
    PAYOUTS: 'PAYOUTS',
    CORPORATE: 'CORPORATE'
}
